import { render } from "./CarrinhoCompras.vue?vue&type=template&id=445b783f"
import script from "./CarrinhoCompras.vue?vue&type=script&lang=js"
export * from "./CarrinhoCompras.vue?vue&type=script&lang=js"

import "./CarrinhoCompras.vue?vue&type=style&index=0&id=445b783f&lang=css"

import exportComponent from "/home/runner/work/santo_cartao_adm_master/santo_cartao_adm_master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__